import React, { useEffect, useState } from 'react'
import { Flex, Spinner, Heading, Image, Button, Box } from 'theme-ui'
import axios from 'axios'
import jsonpAdapter from 'axios-jsonp'
import ContactDetails from '../../General/ContactDetails'
import SocialIcons from '../../General/SocialIcons/SocialIconsV1'
import { nanoid } from 'nanoid'
import checkIfExternalLink from '../../../helpers/checkIfExternalLink'

export default function LocationBoxes(props) {
  const {
    // businessData,
    // configData,
    // pageTitle,
    // gonationID,
    // locationIndex,
    variantName,
    options
  } = props

  const { poweredIDs, containerStyles, containerID, CTASList } = options

  const [locationsData, setLocationData] = useState(null)

  // Fetch the menu data when the template renders.
  const fetchLocationData = async poweredIDs => {
    await Promise.all(
      poweredIDs.map(poweredID => {
        return axios({
          url: `https://data.gonation.com/profile/getname/?profile_id=${poweredID}`,
          adapter: jsonpAdapter
        })
      })
    ).then(res => {
      setLocationData(res)
    })
  }

  useEffect(() => {
    fetchLocationData(poweredIDs)
  }, [poweredIDs])

  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  return (
    <>
      {!locationsData ? (
        <Spinner />
      ) : (
        <Flex
          id={containerID ? containerID : ''}
          variant={`${variantName}.container`}
          className="container"
          sx={styles}
        >
          {locationsData.map((location, index) => {
            const { avatar, name, street, city, state, zip, links, phone, slug } = location.data

            return (
              <Flex variant={`${variantName}.box`} className="box" key={nanoid()}>
                <Box variant={`${variantName}.imageContainer`} className="imageContainer">
                  <Image
                    variant={`${variantName}.logoImg`}
                    className="logoImg"
                    src={`${avatar.imageBaseUrl + '/' + avatar.imagePrefix}`}
                  />
                </Box>
                <Heading variant={`${variantName}.title`} className="title">
                  {name}
                </Heading>

                <Box variant={`${variantName}.CTAS`} className="CTAS">
                  {CTASList
                    ? CTASList[index].map(cta => {
                        return (
                          <Button
                            href={cta.ctaLink}
                            as="a"
                            variant={`${variantName}.CTA`}
                            className="CTA"
                            key={nanoid()}
                            target={checkIfExternalLink(cta.ctaLink) ? '_blank' : ''}
                          >
                            {cta.ctaName}
                          </Button>
                        )
                      })
                    : ''}
                </Box>

                <Box variant={`${variantName}.contactDetailsContainer`} className="contactDetailsContainer">
                  <ContactDetails address={{ name, street, city, state, zip, links }} phone={phone} />
                </Box>
                <Flex variant={`${variantName}.socialIconsContainer`} className="socialIconsContainers">
                  <SocialIcons slug={slug} links={links} />
                </Flex>
              </Flex>
            )
          })}
        </Flex>
      )}
    </>
  )
}
